let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kERrK")).then(() => parcelRequire('f3diu'));